<fieldset [disabled]="disabled">
	@if (schema) {
		<sf-form
			[schema]="schema"
			[ngModel]="model"
			(ngModelChange)="setModelAndEmitChange($event)"
			(onErrorChange)="emitErrorChange($event.value)"
		/>
	}
</fieldset>
